import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container, Sprite } from '@pixi/react';
import * as PIXI from 'pixi.js';
import { useMemo } from 'react';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../../../redux/store';
import { isTestEnvironment } from '../../../../utils/utils';
const MEDAL_IMAGE_SIZE_PX = 128;
const MEDAL_RENDER_SIZE_PX = 16;
export const SeatedPlayerMedalDisplay = ({ seatIndex, visibleMedalIndex, x, y }) => {
    const visibleMedal = useAppSelector((state) => state.poker.seatedPlayers[seatIndex]?.visibleMedals[visibleMedalIndex], shallowEqual);
    const texture = useMemo(() => (visibleMedal ? PIXI.Texture.from(visibleMedal.imageUrl) : undefined), [visibleMedal]);
    if (!visibleMedal || !texture) {
        return null;
    }
    const scale = MEDAL_RENDER_SIZE_PX / MEDAL_IMAGE_SIZE_PX;
    return (_jsx(Container, { "pixi-data": isTestEnvironment() ? { type: 'medal', medalType: visibleMedal.medalType, seatIndex } : null, children: _jsx(Sprite, { texture: texture, scale: scale, x: x, y: y }) }));
};
